const initialState = {
    adjustmentConfigurationGridRowData: [],
    sourceColumnsForSelectionBox: [],
    workflowRuleNames: [],
    workflowRuleNamesForSelectionBox: [],
    workflowConfigurations: {},
    workflowConfigurationRecon: [],
    isAdjustmentConfiguration: false,
    reportReconColumnFields: {},
    serverFolderPaths: [],
    allReportsWorkflow: [],
    dbImportColumns: [],
    isAutoMap: false,
    allFileTemplates: [],
};

export default initialState;
